import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Phone, MessageCircle, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import Header from './Header';
import Footer from './Footer';
import FloatingWhatsApp from './FloatingWhatsApp';

const RiparazioniCaldaiePrati = () => {
  const handleCall = () => {
    window.location.href = 'tel:3287686356';
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/393287686356?text=Ciao,%20ho%20bisogno%20di%20riparazione%20caldaia%20urgente%20zona%20Prati%20Roma.', '_blank');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Riparazione Caldaie Prati Roma H24 | Assistenza Urgente Multimarca</title>
        <meta name="description" content="Riparazione caldaie Prati Roma H24. Caldaia in blocco, no acqua calda, perdite. Arriviamo in 30-60 minuti anche in zone a traffico limitato. Tel: 328 768 6356" />
        <link rel="canonical" href={`${window.location.origin}/riparazioni-caldaie-prati`} />
      </Helmet>
      
      <div className="min-h-screen">
        <Header />
        
        <section className="bg-gradient-to-br from-blue-50 to-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center justify-center gap-2 mb-6">
                <MapPin className="h-8 w-8 text-blue-700" />
                <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
                  Riparazione Caldaie Prati Roma
                </h1>
              </div>
              
              <p className="text-xl text-gray-700 text-center mb-8">
                Assistenza caldaie H24 zona Prati, Trionfale, Balduina, Cipro, Ottaviano. Arriviamo in 30-60 minuti anche in zone a traffico limitato.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
                <Button onClick={handleWhatsApp} size="lg" className="bg-orange-500 hover:bg-orange-600 text-white text-xl px-10 py-7">
                  <MessageCircle className="mr-3 h-7 w-7" />
                  WhatsApp Urgente
                </Button>
                <Button onClick={handleCall} size="lg" className="bg-blue-700 hover:bg-blue-800 text-white text-xl px-10 py-7">
                  <Phone className="mr-3 h-7 w-7" />
                  328 768 6356
                </Button>
              </div>

              <div className="bg-white p-8 rounded-lg shadow-lg">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Assistenza Caldaie Multimarca Zona Prati
                </h2>
                <p className="text-gray-700 text-lg mb-4">
                  SOS Casa Roma è centro assistenza autorizzato per riparazione e manutenzione caldaie di tutte le marche nella zona Prati e quartieri limitrofi. Interveniamo H24 per caldaia in blocco, mancanza acqua calda, problemi di pressione e perdite.
                </p>
                <p className="text-gray-700 text-lg mb-4">
                  <strong>Problemi caldaia risolti a Prati:</strong> Caldaia in blocco o spenta, niente acqua calda, perdita pressione acqua, perdite idrauliche, errori display, fiamma che non parte, rumori anomali, consumo gas elevato.
                </p>
                <p className="text-gray-700 text-lg mb-4">
                  <strong>Marche trattate:</strong> Ariston, Vaillant, Baxi, Beretta, Ferroli, Immergas, Riello, Hermann Saunier Duval, Junkers, Chaffoteaux e tutte le altre marche.
                </p>
                <p className="text-gray-700 text-lg mb-4">
                  <strong>Zone coperte:</strong> Prati, Trionfale, Balduina, Cipro, Ottaviano, Lepanto, Mazzini, Delle Vittorie, Borgo Pio, Vaticano.
                </p>
                <p className="text-gray-700 text-lg">
                  <strong>Pezzi di ricambio originali:</strong> Disponiamo di magazzino ricambi per le principali marche con intervento e riparazione in giornata.
                </p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
        <FloatingWhatsApp />
      </div>
    </>
  );
};

export default RiparazioniCaldaiePrati;
